export const formatActorNameInitialsOrDefault = (user: { firstName: string; lastName: string } | null | undefined) => {
  if (!!user) {
    const surnameChar = user.lastName?.charAt(0);
    return `${user.firstName}${surnameChar ? ' ' + surnameChar : ''}`;
  }

  return 'Someone';
};
